var map = {
	"./Begawan.jpg": 9794,
	"./Ijen.jpg": 1479,
	"./Kepundung.jpg": 7665,
	"./Klojen.jpg": 7912,
	"./Mojolangu.jpg": 4108,
	"./Sawojajar.jpg": 835,
	"./Smoore.jpg": 7182,
	"./Sukun.jpg": 8183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5710;